import { IAlertModalPayload } from '../alert-modal/i-alert-modal-payload';
import { IWithAlertService } from './using-progress';

export function confirmAction(message: string | Partial<IAlertModalPayload>) {
  // eslint-disable-next-line @typescript-eslint/ban-types
  return function <T>(_target: IWithAlertService, _propertyKey: string, descriptor: TypedPropertyDescriptor<(this: IWithAlertService, ...args: any[]) => Promise<T | undefined>>) {
    const originalMethod = descriptor.value;
    if (originalMethod !== undefined) {
      descriptor.value = async function confirm(this: IWithAlertService, ...args) {
        if (!this.alertService) {
          throw new Error('Did you forget to inject AlertService?');
        }

        if (!await this.alertService.confirm(message)) {
          return Promise.resolve(undefined);
        }
        return originalMethod.apply(this, args) as Promise<T>;
      };
    }
    return descriptor;
  };
}
